import type { ApiResponse, Pagination } from "@/types";

import { BaseApi } from "../base.api";

export type AnnouncementAudience = "ALL" | "STUDENTS" | "TEACHERS";
/**
 * `FAILED` — yetkazish yiqilgan e'lon; `SENDING` da uzoq turib qolgani ham
 * backend tomonidan "osilib qolgan" deb tan olinadi va qayta yuborilishi
 * mumkin (`POST /announcements/:id/retry`).
 */
export type AnnouncementStatus = "SCHEDULED" | "SENDING" | "SENT" | "FAILED";

export interface Announcement {
  id: number;
  title: string;
  message: string;
  audience: AnnouncementAudience;
  sendInApp: boolean;
  sendEmail: boolean;
  status: AnnouncementStatus;
  scheduledAt: string | null;
  sentAt: string | null;
  recipientCount: number;
  createdById: number | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateAnnouncementData {
  title: string;
  message: string;
  audience: AnnouncementAudience;
  sendInApp?: boolean;
  sendEmail?: boolean;
  /** ISO sana-vaqt; darhol yuborish uchun berilmaydi. */
  scheduledAt?: string;
}

export interface AudienceCounts {
  all: number;
  students: number;
  teachers: number;
}

/** E'lonlar API (admin) — backend'dagi `AnnouncementsController` ning ko'zgusi. */
export class AnnouncementsApi extends BaseApi {
  private readonly baseUrl: string = "/announcements";

  create(data: CreateAnnouncementData) {
    return this.request.post<Announcement, ApiResponse<Announcement>>(this.baseUrl, data);
  }

  list(filter: { page?: number; limit?: number } = {}) {
    return this.request.get<Announcement[], Pagination<Announcement>>(this.baseUrl, {
      params: filter,
    });
  }

  /** Yiqilgan yoki osilib qolgan e'lonni qayta yuborish. */
  retry(id: number) {
    return this.request.post<Announcement, ApiResponse<Announcement>>(
      `${this.baseUrl}/${id}/retry`,
      {},
    );
  }

  audienceCounts() {
    return this.request.get<AudienceCounts, ApiResponse<AudienceCounts>>(
      `${this.baseUrl}/audience-counts`,
    );
  }
}

export const announcementsApi = new AnnouncementsApi();
